var video_teaser = document.querySelector('.home__videoteaser');

if (video_teaser) {
	var video_trigger = video_teaser.querySelector('.button');
	video_trigger.addEventListener('click', function(event) {
		event.preventDefault();
		var video_elem = document.getElementById('videoteaeser');
		video_teaser.classList.add('is-active');
		video_elem.play();
	});	
}
